namespace TabAurous.Master {
    export interface TargetDistributionForm {
        Code: Serenity.StringEditor;
        January: Serenity.DecimalEditor;
        February: Serenity.DecimalEditor;
        March: Serenity.DecimalEditor;
        April: Serenity.DecimalEditor;
        May: Serenity.DecimalEditor;
        June: Serenity.DecimalEditor;
        July: Serenity.DecimalEditor;
        August: Serenity.DecimalEditor;
        September: Serenity.DecimalEditor;
        October: Serenity.DecimalEditor;
        November: Serenity.DecimalEditor;
        December: Serenity.DecimalEditor;
    }

    export class TargetDistributionForm extends Serenity.PrefixedContext {
        static formKey = 'Master.TargetDistribution';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TargetDistributionForm.init)  {
                TargetDistributionForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(TargetDistributionForm, [
                    'Code', w0,
                    'January', w1,
                    'February', w1,
                    'March', w1,
                    'April', w1,
                    'May', w1,
                    'June', w1,
                    'July', w1,
                    'August', w1,
                    'September', w1,
                    'October', w1,
                    'November', w1,
                    'December', w1
                ]);
            }
        }
    }
}
